import React, { useEffect, useState } from 'react';
import logoGrins from './images/LogoGrins.png';
import logo_extra from './images/logo_extra.png';
import { Image, Box, Text, Menu, MenuButton, MenuList, MenuItem, Button, Flex, Tooltip } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';

import { useLocation } from 'react-router-dom';

const Header = (isVisibleMenuLang) => {
  const { i18n } = useTranslation();
  //Soluzione momentanea per disabilitare il cambio lingua
  const location = useLocation();
  const [isDisabled, setIsDisabled] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
  
  }, [location.pathname]);
  //Fine

  // Imposta sempre la lingua inglese come predefinita al primo caricamento
  // useEffect(() => {
  //   if (i18n.language !== 'en') {
  //     i18n.changeLanguage('en'); 
  //   }
  // }, [i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Cambia la lingua
    console.log()
  };

  return (
    <Box
      p="10px"
      w="100%"
      bg="rgba(11,78,90,255)"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      {/* Logo sinistro */}
      <Box>
        <Image src={logoGrins} alt="Logo Grins Foundation" height="60px" />
      </Box>

      {/* Logo destro e selettore lingua */}
      <Flex alignItems="center" gap="20px">
        <Image src={logo_extra} alt="Finanziato dall'Unione Europea" height="60px" />

        {/* Copyright Box */}
        <Box
          borderRadius="10px"
          bgColor="yellowgreen"
          p="8px"
          textAlign="center"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Text color="white" fontSize="sm">
            Copyright © 2023 Amelia Test
          </Text>
        </Box>

        {/* Selettore lingua */}



        {isVisibleMenuLang && (
          <Menu>
            <Tooltip label={t('toolTip.header.tooltip.changeLanguage')} placement="bottom" >
              <span>
                <MenuButton
                  as={Button}
                  rightIcon={<ChevronDownIcon />}
                  bgColor="white"
                  color="rgba(11,78,90,255)"
                  _hover={{ bg: 'gray.200' }}
                  _focus={{ outline: 'none' }}
                  display="flex"
                  alignItems="center"
                  gap="10px"
                  disabled={isDisabled}
                >
                  {/* Bandierina e Lingua Attuale */}
                  <Flex alignItems="center" gap="5px">
                    <Image
                      src={i18n.language === 'en' ? '/images/flags/it.png' : '/images/flags/en.png'}
                      alt={i18n.language === 'en' ? 'English Flag' : 'Italian Flag'}
                      boxSize="20px"
                    />
                    {i18n.language === 'en' ? 'English' : 'Italiano'}
                  </Flex>
                </MenuButton>
              </span>
            </Tooltip>
            <MenuList>
              {/* Lingua Inglese */}
              {i18n.language !== 'en' && (
                <MenuItem onClick={() => changeLanguage('en')} display="flex" gap="10px">
                  <Image src="/images/flags/it.png" alt="English Flag" boxSize="20px" />
                  English
                </MenuItem>
              )}

              {/* Lingua Italiana */}
              {i18n.language !== 'it' && (
                <MenuItem onClick={() => changeLanguage('it')} display="flex" gap="10px">
                  <Image src="/images/flags/en.png" alt="Italian Flag" boxSize="20px" />
                  Italiano
                </MenuItem>
              )}
            </MenuList>
          </Menu>
        )}



      </Flex>
    </Box>
  );
};

export default Header;
